import React from "react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { mapNationalityForFormSelect } from "@utils";
import { CountryDataType } from "@data-types/membership/registration";

export default function PartnerRegistrationNationality(props: {
	countryData: CountryDataType[] | null;
	labelClassName?: string;
}) {
	const { countryData, labelClassName } = props;

	return (
		<FormSelectField
			label="registration:NATIONALITY_LABEL"
			labelClassName={labelClassName}
			required
			name="nationalityId"
			placeholder="registration:NATIONALITY_PLACEHOLDER"
			className="form__field"
			dropdownData={mapNationalityForFormSelect(countryData)}
		/>
	);
}
